import { ServerFetch } from '../main-model'

export default class StockSettingZoneModel extends ServerFetch {
    getStockSettingZoneBy = (data) => this.authFetch({
        url: 'stock-setting-zone/getStockSettingZoneBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}